<nav
  class="navbar"
  [ngClass]="{
    landing: isLanding,
    internal: isInternal
  }"
>
  <div class="navbar-container">
    <h1 class="nav-title">Vitrine Premiada</h1>

    <button class="btn-enter" type="button" (click)="onActionClick()">
      {{ buttonText }}
      <mat-icon>login</mat-icon>
    </button>
  </div>
</nav>
